import Page from "webPage/Page";
import Track from "util/Track";
import $ from "jquery";
import {handleScrollingSection} from "util/scrolling-section";

Page.register('page-template-technologies', () => {
    new Track($('.js-testimonials-track-wrap'), {
        classes: {
            block: "testimonials-track",
        },
    });

    handleScrollingSection($('.js-scrolling-logos'));
    handleScrollingSection($('.js-scrolling-logos-left'), "left");
});
